import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import { ENUM_FILOGIX_STATUS } from "@Shared/js/enum";
import { filter, isEmpty } from "lodash";
export const CURRENT_COMMISSIONS_FEES = "CURRENT_COMMISSIONS_FEES";
export const CURRENT_COMMISSIONS_FEES_TOTAL = "CURRENT_COMMISSIONS_FEES_TOTAL";
import { denormalize } from "normalizr";
import { commissionDeductionsSchema, commissionsFeesSchema } from "./lender-submit-schema";
export const GET_COMMISSION_DEDUCTIONS = "GET_COMMISSION_DEDUCTIONS";
export const GET_COMMISSION_DEDUCTIONS_TOTAL = "GET_COMMISSION_DEDUCTIONS_TOTAL";
export const GET_COMMISSION_DETAILS_PARTICIPANTS = "GET_COMMISSION_DETAILS_PARTICIPANTS";
export const GET_COMMISSIONS_NOTE = "GET_COMMISSIONS_NOTE";
export const GET_COMMISSION_DETAILS_FIRM_PERCENTAGE = "GET_COMMISSION_DETAILS_FIRM_PERCENTAGE";
export const GET_COMMISSION_DETAILS_SPLIT_TYPE = "GET_COMMISSION_DETAILS_SPLIT_TYPE";
export const ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE = "ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE";
export const GET_COMMISSION_DETAILS_PRIMARY_CONTACT = "GET_COMMISSION_DETAILS_PRIMARY_CONTACT";
export const IS_AGENTS_SPLIT_SUMMARY_COMPLETED = "IS_AGENTS_SPLIT_SUMMARY_COMPLETED";
export const CO_BROKERING_HISTORY = "CO_BROKERING_HISTORY";
export const IS_MORTGAGE_CO_BROKERED = "IS_MORTGAGE_CO_BROKERED";
export const CO_BROKERING_BROKERAGES = "CO_BROKERING_BROKERAGES";
export const CO_BROKERING_BROKERAGES_LOADED = "CO_BROKERING_BROKERAGES_LOADED";
export const CO_BROKERING_BROKERAGES_COUNT = "CO_BROKERING_BROKERAGES_COUNT";
export const CO_BROKERING_AGENTS = "CO_BROKERING_AGENTS";
export const CO_BROKERING_AGENTS_COUNT = "CO_BROKERING_AGENTS_COUNT";
export const CO_BROKERING_LOADING_AGENTS = "CO_BROKERING_LOADING_AGENTS";
export const CO_BROKERING_AGENTS_FULLY_LOADED = "CO_BROKERING_AGENTS_FULLY_LOADED";
export default {
  getSubmissionHistory: state => {
    return state.submissionHistory;
  },
  lenderResponses: state => {
    return filter(state.submissionHistory.byId, submission => !isEmpty(submission.lenderResponse));
  },
  selectedAMLCreditSubjects: state => {
    var _context;
    return _filterInstanceProperty(_context = state.creditSubjects).call(_context, subject => subject.AML);
  },
  selectedPEPCreditSubjects: state => {
    var _context2;
    return _filterInstanceProperty(_context2 = state.creditSubjects).call(_context2, subject => subject.PEP);
  },
  selectedBureauCreditSubjects: state => {
    var _context3;
    return _filterInstanceProperty(_context3 = state.creditSubjects).call(_context3, subject => subject.bureau);
  },
  [CURRENT_COMMISSIONS_FEES]: (state, getters) => {
    const currentApplicationId = getters["CURRENT_APPLICATION_ID"];
    if (!state.commissions.fees.byApplication[currentApplicationId]) return [];
    const {
      allIds,
      byId
    } = state.commissions.fees.byApplication[currentApplicationId][state.commissions.currentCommissionsMortgageType] || {};
    if (allIds) return denormalize(allIds, [commissionsFeesSchema], {
      commissionsFees: byId
    });else return [];
  },
  [CURRENT_COMMISSIONS_FEES_TOTAL]: state => {
    return state.totalCommissionFees;
  },
  [GET_COMMISSIONS_NOTE]: state => applicationId => {
    var _state$commissions$co, _state$commissions$co2, _state$commissions$co3, _state$commissions$co4;
    return (_state$commissions$co = (_state$commissions$co2 = state.commissions.commissionDetails) == null ? void 0 : (_state$commissions$co3 = _state$commissions$co2.byApplication) == null ? void 0 : (_state$commissions$co4 = _state$commissions$co3[applicationId]) == null ? void 0 : _state$commissions$co4.note) != null ? _state$commissions$co : "";
  },
  [GET_COMMISSION_DEDUCTIONS]: state => applicationId => {
    var _state$commissions$de, _state$commissions$de2;
    if ((_state$commissions$de = state.commissions.deductions.byApplication) != null && (_state$commissions$de2 = _state$commissions$de[applicationId]) != null && _state$commissions$de2.allIds) {
      const {
        allIds,
        byId
      } = state.commissions.deductions.byApplication[applicationId];
      return denormalize(allIds, [commissionDeductionsSchema], {
        commissionDeductions: byId
      });
    }
    return [];
  },
  [GET_COMMISSION_DEDUCTIONS_TOTAL]: state => applicationId => {
    var _state$commissions$de3, _state$commissions$de4;
    return (_state$commissions$de3 = state.commissions.deductions.byApplication) == null ? void 0 : (_state$commissions$de4 = _state$commissions$de3[applicationId]) == null ? void 0 : _state$commissions$de4.totalDeductions;
  },
  [GET_COMMISSION_DETAILS_PARTICIPANTS]: state => applicationId => {
    var _state$commissions$co5, _state$commissions$co6, _state$commissions$co7, _state$commissions$co8, _state$commissions$co9, _state$commissions$co0, _state$commissions$co1;
    const participants = (_state$commissions$co5 = (_state$commissions$co6 = state.commissions.commissionDetails.byApplication) == null ? void 0 : (_state$commissions$co7 = _state$commissions$co6[applicationId]) == null ? void 0 : (_state$commissions$co8 = _state$commissions$co7.participants) == null ? void 0 : _state$commissions$co8.byId) != null ? _state$commissions$co5 : null;
    return participants ? _Object$values((_state$commissions$co9 = state.commissions.commissionDetails.byApplication) == null ? void 0 : (_state$commissions$co0 = _state$commissions$co9[applicationId]) == null ? void 0 : (_state$commissions$co1 = _state$commissions$co0.participants) == null ? void 0 : _state$commissions$co1.byId) : [];
  },
  [GET_COMMISSION_DETAILS_FIRM_PERCENTAGE]: state => applicationId => {
    var _state$commissions$co10, _state$commissions$co11, _state$commissions$co12;
    return (_state$commissions$co10 = (_state$commissions$co11 = state.commissions.commissionDetails.byApplication) == null ? void 0 : (_state$commissions$co12 = _state$commissions$co11[applicationId]) == null ? void 0 : _state$commissions$co12.firmSplit) != null ? _state$commissions$co10 : 100;
  },
  [GET_COMMISSION_DETAILS_SPLIT_TYPE]: state => applicationId => {
    var _state$commissions$co13, _state$commissions$co14, _state$commissions$co15;
    return (_state$commissions$co13 = (_state$commissions$co14 = state.commissions.commissionDetails.byApplication) == null ? void 0 : (_state$commissions$co15 = _state$commissions$co14[applicationId]) == null ? void 0 : _state$commissions$co15.splitType) != null ? _state$commissions$co13 : "before";
  },
  [GET_COMMISSION_DETAILS_PRIMARY_CONTACT]: state => applicationId => {
    var _state$commissions$co16, _state$commissions$co17;
    const participants = _Object$values((_state$commissions$co16 = state.commissions.commissionDetails.byApplication) == null ? void 0 : (_state$commissions$co17 = _state$commissions$co16[applicationId]) == null ? void 0 : _state$commissions$co17.participants.byId);
    return _findInstanceProperty(participants).call(participants, participant => participant.primaryContact);
  },
  [ACCEPTED_LENDER_SUBMISSION_BY_MORTGAGE_TYPE]: state => {
    var _context4, _context5, _state$submissionHist;
    return _reduceInstanceProperty(_context4 = _filterInstanceProperty(_context5 = _Object$values(((_state$submissionHist = state.submissionHistory) == null ? void 0 : _state$submissionHist.byId) || {})).call(_context5, submission => submission.status === ENUM_FILOGIX_STATUS.accepted)).call(_context4, (byMortgageType, submission) => {
      byMortgageType[submission.mortgageType] = submission;
      return byMortgageType;
    }, {});
  },
  [IS_AGENTS_SPLIT_SUMMARY_COMPLETED]: (state, getters) => applicationsId => {
    const participants = getters.GET_COMMISSION_DETAILS_PARTICIPANTS(applicationsId);
    const splitsTotal = _reduceInstanceProperty(participants).call(participants, (acc, participant) => {
      var _participant$agentSpl;
      acc += (_participant$agentSpl = participant.agentSplit) != null ? _participant$agentSpl : 0;
      return acc;
    }, 0);
    return splitsTotal === 100;
  },
  [CO_BROKERING_HISTORY]: state => state.coBrokering.coBrokeringHistory,
  [CO_BROKERING_BROKERAGES]: state => state.coBrokering.brokerages,
  [CO_BROKERING_BROKERAGES_COUNT]: state => state.coBrokering.brokerageCount,
  [CO_BROKERING_BROKERAGES_LOADED]: state => state.coBrokering.brokerages.length,
  [CO_BROKERING_AGENTS]: state => state.coBrokering.agents,
  [CO_BROKERING_AGENTS_COUNT]: state => state.coBrokering.totalAgents,
  [CO_BROKERING_LOADING_AGENTS]: state => state.coBrokering.loadingAgents,
  [CO_BROKERING_AGENTS_FULLY_LOADED]: state => state.coBrokering.agents.length && state.coBrokering.totalAgents === state.coBrokering.agents.length,
  [IS_MORTGAGE_CO_BROKERED]: state => mortgageType => {
    var _context6;
    const foundCobrokeredHistory = _findInstanceProperty(_context6 = state.coBrokering.coBrokeringHistory).call(_context6, ({
      mortgageType: historyMortgageType
    }) => historyMortgageType === mortgageType);
    return foundCobrokeredHistory && foundCobrokeredHistory.agentName;
  }
};